
import React, { useState } from 'react'
import { Form, Input, Button, Statistic } from 'antd';
import { LoginContainer, FlexContainer } from './style';
import { Link } from 'react-router-dom';
import history from '../../history';
import { connect } from 'react-redux';
import {getEmail,resendEmail} from '../../actions/auth';
const { Countdown } = Statistic;
const ForgotPasswordverification = ({getEmail,resendEmail}) => {
    const [verified, setVerified] = useState(null)
    const [resend, setResend] = useState(false)
    const [email, setEmail] = useState(false)
    const onFinish = async (values) => {
        setEmail(values.email)
        const res =  await getEmail(values.email)
        setVerified(res)
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
      const handleResendEmail = () => {
            setResend(true)
      }
      const submitResendEmail = async () => {

            const res = await resendEmail(email)
            if(res === 201){
                setResend(false)
            }
      }
      
const deadline = Date.now() + 1000 * 120;
// console.log(resend)
    return ( 
        <FlexContainer>
            <LoginContainer>
                <img src='./logo.png' />
                <h2 style={{margin: '30px 0px', alignSelf: 'center'}}>Forgot Password</h2>
                
                {verified === 201 ? 
                <>
                    <h3 style={{margin: '50px 0px 10px 0px'}}>We have sent an email with a reset password link to your email</h3>
                    <p style={{margin: '20px 0px', color: 'gray'}}>If you do not receive an email, please check your spam folder. Also, please verify that you entered a valid email address.</p>
                
                {resend === true ? 
                
                <Button type="primary" htmlType="submit" onClick={() =>submitResendEmail() }>
                    Resend verification email
                </Button>
                : 
                <Countdown style={{textAlign: 'center'}} title="Resend verification email" size="small" value={deadline} onFinish={handleResendEmail} />}
                </>
                :
                <>
                
                <Form
                name="basic"
                labelCol={{
                    span: 24,
                }}
                wrapperCol={{
                    span: 24,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{width: '100%'}}
                requiredMark={false}
                >
                <Form.Item
                    label="Your registered email "
                    name="email"
                    rules={[
                    {
                        required: true,
                        message: 'Please input your email!',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>
{/* 
                <Form.Item
                    label="Confirm Password"
                    name="confirm_password"
                    rules={[
                    {
                        required: true,
                        message: 'Please input your password!',
                    },
                    ]}
                >
                    <Input.Password />
                </Form.Item> */}


                <Form.Item
                    style={{textAlign: 'center'}}
                >
                    <Button type="primary" htmlType="submit">
                        Get verification email
                    </Button>
                </Form.Item>
                <p>Don't have any account ? <Link to="/registration">Register Now</Link></p>
                <p><Link to="/login">Back to Login</Link></p>
                </Form>
                </>
                }
            </LoginContainer>
        </FlexContainer>
     );
}
 
export default connect(null,{getEmail,resendEmail})(ForgotPasswordverification);